const sendVwoEvent = (price, plan) => {
  // Do not change anything in the following two lines
  window.VWO = window.VWO || [];
  window.VWO.event = window.VWO.event || function () {window.VWO.push(['event'].concat([].slice.call(arguments)))};

  window.VWO.event('purchaseFinished', {price, plan});
};

export default sendVwoEvent;
